import { render, staticRenderFns } from "./veStuPunishShow.vue?vue&type=template&id=290441f3&scoped=true"
import script from "./veStuPunishShow.vue?vue&type=script&lang=js"
export * from "./veStuPunishShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290441f3",
  null
  
)

export default component.exports